const INVOICE_STATUS_OPTIONS_COLORS = [
    { label: 'DRAFT',          color: '#94A3B8' }, // Slate grey
    { label: 'ISSUED',         color: '#4A90E2' }, // Muted Sky Blue
    { label: 'SENT',           color: '#6366F1' }, // Indigo
    { label: 'PARTIALLY_PAID', color: '#F59E0B' }, // Amber
    { label: 'PAID',           color: '#7DCFB6' }, // Soft Sage Green
    { label: 'OVERDUE',        color: '#F4C067' }, // Warm Beige Yellow
    { label: 'CANCELLED',      color: '#E07A5F' }, // Subtle Terracotta Red
    { label: 'WRITTEN_OFF',    color: '#64748B' }, // Cool Slate
    { label: 'PENDING',        color: '#4A90E2' }, // kept for backward compat
];

export default INVOICE_STATUS_OPTIONS_COLORS;
